import React from 'react'
import './CostBreakdown.css'

const CostBreakdown = ({ data }) => {
  const maxValue = Math.max(...data.map(item => item.value), 100)

  return (
    <div className="chart-card">
      <h2 className="chart-title">Cost Breakdown</h2>
      <div className="cost-breakdown-list">
        {data.map((item, index) => {
          const percentage = (item.value / maxValue) * 100
          return (
            <div key={index} className="cost-item">
              <div className="cost-item-header">
                <span className="cost-item-label">{item.label}</span>
                <span className="cost-item-value">${item.value.toLocaleString()}</span>
              </div>
              <div className="progress-bar-container">
                <div 
                  className="progress-bar"
                  style={{ 
                    width: `${percentage}%`,
                    backgroundColor: item.color || '#2563eb'
                  }}
                ></div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CostBreakdown













